import { Component, OnInit } from '@angular/core';
import {FilterModalComponent} from '../../../../search/search-list/filters/filter-block/filter-modal/filter-modal.component';
import {FiltersService} from '../../../../search/search-list/filters/filters.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '../../../translate.service';
import {SearchService} from '../../../../search/search.service';
import {ActivatedRoute} from '@angular/router';
import {SortService} from '../../../sort.service';
import {MessageService} from '../../../../messages/message.service';
import {AppConfigService} from '../../../../config/app-config.service';
import {ListService} from '../../list.service';
import {FacetService} from '../facet.service';

@Component({
  selector: 'app-facet-modal-component',
  templateUrl: './facet-modal-component.component.html',
  styleUrls: ['./facet-modal-component.component.scss']
})
export class FacetModalComponent extends FilterModalComponent{

  constructor(public activeModal: NgbActiveModal,
              public translateService: TranslateService,
              public filtersService: FiltersService,
              protected searchService: SearchService,
              protected route: ActivatedRoute,
              protected sortService: SortService,
              protected messageService: MessageService,
              protected appConfigService: AppConfigService,
              protected listService: ListService,
              public facetService: FacetService) {
    super(activeModal, translateService, filtersService, searchService, route, sortService, messageService, appConfigService, listService);
  }


  protected getFilterService(): FiltersService {
    return this.facetService;
  }

}
